export const CHART_COLORS = ['var(--chart-1)', 'var(--chart-2)', 'var(--chart-3)', 'var(--chart-4)'];

export function isNum(v) {
  return typeof v === 'number' && Number.isFinite(v);
}

export function clamp(v, lo, hi) {
  return Math.min(hi, Math.max(lo, v));
}

/** Rounded whole-number percent of part/whole, or null when it cannot be computed honestly. */
export function pctOf(part, whole) {
  if (!isNum(part) || !isNum(whole) || whole <= 0) return null;
  return Math.round((part / whole) * 100);
}

export function colorAt(i) {
  return CHART_COLORS[i % CHART_COLORS.length];
}
